<template>
  <div id="payableTable">
    <section class="noSide">
      <div class="line">
        <el-row
          type="flex"
          :gutter="gutter"
        >
          <el-col
            class="leftAlign"
            :span="colSpan.one"
          >
            <span class="emphasize">
              DESCRIPTION
            </span>
          </el-col>
          <el-col :span="colSpan.two">
            Order Qty
          </el-col>
          <el-col :span="colSpan.two">
            Unit Price
          </el-col>
          <el-col :span="colSpan.two">
            Amount
          </el-col>
        </el-row>
      </div>
      <div class="line">
        <el-row
          type="flex"
          :gutter="gutter"
        >
          <el-col
            class="leftAlign"
            :span="colSpan.one"
          >
            {{
              report.vat.description ? report.vat.description :
              'Digital Coaching Platform Services as Reference Details'
            }}
          </el-col>
          <el-col :span="colSpan.two">
            1
          </el-col>
          <el-col :span="colSpan.two">
            {{ formattedAmount.amount }}
          </el-col>
          <el-col :span="colSpan.two">
            {{ formattedAmount.amount }}
          </el-col>
        </el-row>
      </div>
      <div class="line">
        <el-row
          type="flex"
          :gutter="gutter"
        >
          <el-col :span="colSpan.three">
            Subtotal (excl. VAT)
          </el-col>
          <el-col :span="colSpan.four">
            {{ formattedAmount.amount }}
          </el-col>
        </el-row>
      </div>
      <div class="line">
        <el-row
          type="flex"
          :gutter="gutter"
        >
          <el-col :span="colSpan.three">
            VAT
          </el-col>
          <el-col :span="colSpan.two">
            {{ report.vat.percentage * 100 }}%
          </el-col>
          <el-col :span="colSpan.two">
            {{ formattedAmount.vat }}
          </el-col>
        </el-row>
      </div>
      <div class="line">
        <el-row
          type="flex"
          :gutter="gutter"
        >
          <el-col :span="colSpan.three">
            <span class="emphasize">
              TOTAL
            </span>
          </el-col>
          <el-col :span="colSpan.two">
            <span class="emphasize">
              EUR
            </span>
          </el-col>
          <el-col :span="colSpan.two">
            <span class="emphasize">
              {{ formattedAmount.total_amount }}
            </span>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    report: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    gutter: 6,
    colSpan: {
      one: 9,
      two: 5,
      three: 14,
      four: 10,
    },
  }),

  computed: {
    formattedAmount() {
      const numbers = {
        amount: 0,
        vat: 0,
        total_amount: 0,
      };

      if (this.report.amount) {
        numbers.amount = `${this.report.amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      if (this.report.vat_amount) {
        numbers.vat = `${this.report.vat_amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      if (this.report.total_amount) {
        numbers.total_amount = `${this.report.total_amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      return numbers;
    },
  },
};
</script>

<style lang="scss" scoped>
  #payableTable {
    width: 100%;

    section {
      font-size: 14px;
      padding: 10px 10px;
      white-space: pre-line;

      &.noSide {
        padding: 10px 0;
      }

      .emphasize {
        font-size: 15px;
        font-weight: bold;
      }

      .line {
        padding: 1px 10px;
        border-top: 1px solid black;

        &:last-child {
          border-bottom: 1px solid black;
        }

        .el-col {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          &.rightAlign {
            justify-content: flex-end;
          }

          &.leftAlign {
            justify-content: flex-start;
          }
        }
      }
    }
  }
</style>
